import {Injectable} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {ReportsService as ReportsApiService} from '../../api/services/reports.service';
import * as _ from 'lodash';
import {GroupsSummaryExportRequest} from '../../api/models/groups-summary-export-request';
import {GroupAgentsSummaryExportModel} from '../../api/models/group-agents-summary-export-model';

@Injectable()
export class AgentGroupsSummaryService {

  public exportColumns: any[] = [
    {id: _.uniqueId('id_'), field: '_id', title: 'Account Number', width: 10},
    {id: _.uniqueId('id_'), field: 'name', title: 'Name', width: 10},
    {id: _.uniqueId('id_'), field: 'type', title: 'Type', width: 10},
    {id: _.uniqueId('id_'), field: 'count', title: 'Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'answered', title: 'Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'missed', title: 'Abandoned', width: 10},
    {id: _.uniqueId('id_'), field: 'durationIvrFormatted', title: 'Total Duration while IVR', width: 10},
    {id: _.uniqueId('id_'), field: 'durationRingFormatted', title: 'Total Duration while Ring', width: 10},
    {id: _.uniqueId('id_'), field: 'durationHoldFormatted', title: 'Total Duration while Hold', width: 10},
    {id: _.uniqueId('id_'), field: 'durationTalkFormatted', title: 'Total Duration while Talk', width: 10},
    {id: _.uniqueId('id_'), field: 'durationIdleFormatted', title: 'Total Duration while IDLE', width: 10},
    {id: _.uniqueId('id_'), field: 'rwCount', title: 'Redirected while Waiting', width: 10},
    {id: _.uniqueId('id_'), field: 'rrCount', title: 'Redirected while Ringing', width: 10},
    {id: _.uniqueId('id_'), field: 'hwCount', title: 'Hung Up while Waiting', width: 10},
    {id: _.uniqueId('id_'), field: 'hrCount', title: 'Hung Up while Ringing', width: 10},
    {id: _.uniqueId('id_'), field: 'raCount', title: 'Redirected Anonymous Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'hbCount', title: 'Maximum Calls Reached', width: 10},
    {id: _.uniqueId('id_'), field: 'userCount', title: 'Callers Redirected to Other Destinations', width: 10},
    {id: _.uniqueId('id_'), field: 'soapCount', title: 'Redirected Due to Server Application', width: 10},
  ];
  public exportAgentsColumns: any[] = [
    {id: _.uniqueId('id_'), field: '_id', title: 'Account Number', width: 10},
    {id: _.uniqueId('id_'), field: 'name', title: 'Name', width: 10},
    {id: _.uniqueId('id_'), field: 'totalAnswered', title: 'Total Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'totalMissed', title: 'Calls Not Accepted', width: 10},
    {id: _.uniqueId('id_'), field: 'totalLoggedInFormatted', title: 'Total Logged In', width: 10},
    {id: _.uniqueId('id_'), field: 'avgDurationRingFormatted', title: 'Average Ring Time', width: 10},
    {id: _.uniqueId('id_'), field: 'avgDurationTalkFormatted', title: 'Average Talk Time', width: 10}
  ];
  public aggregates: any[] = [
    {field: 'count', aggregate: 'sum'},
    {field: 'answered', aggregate: 'sum'},
    {field: 'missed', aggregate: 'sum'},
    {field: 'durationIvr', aggregate: 'sum'},
    {field: 'durationHold', aggregate: 'sum'},
    {field: 'durationIdle', aggregate: 'sum'},
    {field: 'durationRing', aggregate: 'sum'},
    {field: 'durationTalk', aggregate: 'sum'},
    {field: 'rwCount', aggregate: 'sum'},
    {field: 'rrCount', aggregate: 'sum'},
    {field: 'hwCount', aggregate: 'sum'},
    {field: 'hrCount', aggregate: 'sum'},
    {field: 'raCount', aggregate: 'sum'},
    {field: 'hbCount', aggregate: 'sum'},
    {field: 'userCount', aggregate: 'sum'},
  ];

  constructor(private authService: AuthService, private reportsApiService: ReportsApiService) {

  }

  public async exportLogs(state: GroupsSummaryExportRequest): Promise<void> {
    console.log(state);

    const response = await this.reportsApiService.groupsSummaryGetExport({body: state}).toPromise();

    const blob = new Blob([this.s2ab(atob(response))], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    a.href = url;
    a.download = 'agent-groups-list.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);

    return;
  }

  public async exportAgentLogs(state: GroupAgentsSummaryExportModel): Promise<void> {
    console.log(state);

    const response = await this.reportsApiService.groupsSummaryGetExportAgents({body: state}).toPromise();

    const blob = new Blob([this.s2ab(atob(response))], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    a.href = url;
    a.download = 'group-agents-list.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);

    return;
  }

  s2ab(s: string) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }

}
